import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { cn } from '../../../utils/utils';
import users from '../../users';
import './expandable-search-input.scss';

type Props = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    expandedWidth?: string | number;
    forceDarkMode?: 'light' | 'dark';
};

const ExpandableSearchInput = ({
    value,
    onChange,
    placeholder = 'Buscar...',
    className,
    expandedWidth = '250px',
    forceDarkMode
}: Props) => {
    const darkMode = useSelector(users.selectors.isDarkMode);
    const isDarkMode = forceDarkMode ? forceDarkMode === 'dark' : darkMode;
    
    const [isExpanded, setIsExpanded] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const handleContainerClick = () => {
        if (!isExpanded) {
            setIsExpanded(true);
            setTimeout(() => {
                inputRef.current?.focus();
            }, 50);
        }
    };

    const handleBlur = () => {
        if (!value) {
            setIsExpanded(false);
        }
    };

    const isOpen = isExpanded || !!value;

    return (
        <div
            className={cn(
                'expandable-search',
                { 'expandable-search--dark': isDarkMode },
                { 'expandable-search--expanded': isOpen },
                className
            )}
            style={{ width: isOpen ? expandedWidth : '50px' }}
            onClick={handleContainerClick}
        >
            <div className="expandable-search__icon" onClick={() => {
                if (isOpen) {
                    inputRef.current?.focus();
                }
            }}>
                <i className="fa-solid fa-search"></i>
            </div>
            <input
                ref={inputRef}
                className="expandable-search__input"
                value={value}
                onChange={e => onChange(e.target.value)}
                onBlur={handleBlur}
                placeholder={placeholder}
                autoComplete="off"
            />
        </div>
    );
};

export default ExpandableSearchInput;